
import { GoogleGenAI, GenerateContentResponse } from "@google/genai";

/**
 * Genera contenido de guion creativo usando Gemini 3 Pro.
 */
export const generateCreativeText = async (prompt: string): Promise<string> => {
  // Initialize GoogleGenAI with API key directly from process.env
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  try {
    const response: GenerateContentResponse = await ai.models.generateContent({
      model: 'gemini-3-pro-preview',
      contents: prompt,
      config: {
        systemInstruction: "You are 'THE DIRECTOR', the elite AI creative engine for ¡RR3VERENT!A. Your tone is bold, avant-garde, and professional. You provide high-end cinematic insights, scripts, and visual concepts.",
        temperature: 0.9,
      }
    });
    // Directly access the .text property
    return response.text || "SYSTEM_ERROR: NULL_RESPONSE";
  } catch (error) {
    console.error("Text Generation Error:", error);
    throw error;
  }
};

/**
 * Genera arte conceptual usando Gemini 2.5 Flash Image.
 */
export const generateConceptArt = async (prompt: string): Promise<string> => {
  // Initialize GoogleGenAI with API key directly from process.env
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  try {
    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash-image',
      contents: {
        parts: [{ text: `Cinematic concept art, high-fidelity, dramatic lighting, professional cinematography, 8k. Subject: ${prompt}` }],
      },
      config: {
        imageConfig: {
          aspectRatio: "16:9"
        }
      }
    });

    // Safely iterate through response parts to extract image data
    const parts = response.candidates?.[0]?.content?.parts;
    if (parts) {
      for (const part of parts) {
        if (part.inlineData && part.inlineData.data) {
          return `data:image/png;base64,${part.inlineData.data}`;
        }
      }
    }
    throw new Error("ERR_NO_VISUAL_DATA");
  } catch (error) {
    console.error("Image Generation Error:", error);
    throw error;
  }
};